import ActorPopup from './ActorPopup';

export default ActorPopup;
